export enum BankAccountType {
    /** 0 */
    UNKNOWN_BANK_ACCOUNT_TYPE = 'UNKNOWN_BANK_ACCOUNT_TYPE',
    /** 1 */
    ACH = 'ACH',
    /** 2 */
    WIRE = 'WIRE'
}
